import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
/* eslint-disable flowtype/require-valid-file-annotation */
/* eslint no-param-reassign: 0 */

/**
 * Safe join 2 parts of urls with '/'
 */
export function joinUrl(partA, partB) {
  // if partB is an absolute url, don't join anything and return it.
  if (/^http/.test(partB)) {
    return partB;
  }
  var parts = [];
  if (partA.match(/\/$/)) {
    parts.push(partA.substr(0, partA.length - 1));
  } else {
    parts.push(partA);
  }
  if (partB.match(/^\//)) {
    parts.push(partB.substr(1));
  } else {
    parts.push(partB);
  }
  var joinedUrl = parts.join('/');
  try {
    return new URL(joinedUrl).href;
  } catch (err) {
    // TypeError [ERR_INVALID_URL]
    return joinedUrl;
  }
}

/**
 * Merge fetch options.
 */
export function mergeOptions() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce(function (accumulator) {
    var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread(_objectSpread(_objectSpread({}, accumulator), src), {}, {
      headers: _objectSpread(_objectSpread({}, accumulator.headers), src.headers)
    });
  }, {});
}
export function hasQuery(url) {
  return url.indexOf('?') > -1;
}

/**
 * Serialize query string params
 */
export function serializeQuery(params) {
  return _Object$keys(params).reduce(function (query, param) {
    if (params[param] !== undefined) {
      if (Array.isArray(params[param])) {
        query.push(params[param].map(function (value) {
          return "".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(value));
        }).join('&'));
      } else {
        query.push("".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(params[param])));
      }
    }
    return query;
  }, []).join('&');
}

/**
 * Add extra properties to error object.
 *
 * WARNING: mutate original object
 *
 * @param  {Error}  error          Original Error
 * @return Error
 */
export function upgradeError(error) {
  error.isTimeoutError = function () {
    return !!error.toString().match(/network timeout/);
  };
  return error;
}

/**
 * Upgrade the response object.
 *
 * Add `response.data` with decoded payload depending on response content type.
 *
 * @param  {Object} response
 * @return {Object} Mutated response
 */
export function upgradeResponse(response) {
  var contentType = '';
  if (response && response.headers && response.headers.get('Content-Type')) {
    contentType = response.headers.get('Content-Type').split(';')[0];
  }
  switch (contentType.toLowerCase()) {
    case 'json':
    case 'application/json':
      return response.json().then(function (json) {
        response.data = json;
        return response;
      }).catch(function (err) {
        err.name = 'FetcherParseError';
        err.message = "Couldn't parse response from json.";
        return _Promise.reject(err);
      });
    case 'application/zip':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      // Excel (XLSX) documents
      return response.blob().then(function (blob) {
        response.data = blob;
        return response;
      }).catch(function (err) {
        err.name = 'FetcherParseError';
        err.message = "Couldn't parse response from blob.";
        return _Promise.reject(err);
      });
    default:
      return response.text().then(function (text) {
        response.data = text;
        return response;
      }).catch(function (err) {
        err.name = 'FetcherParseError';
        err.message = "Couldn't parse response from text.";
        return _Promise.reject(err);
      });
  }
}

/**
 * FIXME check content type from options.headers if provided.
 * default assume this is JSON
 */
export function computeBodyAndOptions(body) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newOptions = _objectSpread({}, options);
  var isMultipart = newOptions.headers && newOptions.headers['Content-Type'] === 'multipart/form-data';
  if (isMultipart) {
    delete newOptions.headers['Content-Type'];
    return _objectSpread({
      body: body
    }, newOptions);
  }
  if (body !== null && _typeof(body) === 'object') {
    if (!newOptions.headers) {
      newOptions.headers = {};
    }
    if (!newOptions.headers['Content-Type']) {
      newOptions.headers['Content-Type'] = 'application/json';
    }
    return _objectSpread({
      body: _JSON$stringify(body)
    }, newOptions);
  }
  return _objectSpread({
    body: body
  }, newOptions);
}